import { GetAccountResponse } from '../../types/accounts/accounts.types';
import {
  GET_ACCOUNT_REQUEST,
  GET_ACCOUNT_SUCCESS,
  GET_ACCOUNT_FAILURE,
  INVITE_USER_TO_ACCOUNT_REQUEST,
  INVITE_USER_TO_ACCOUNT_SUCCESS,
  INVITE_USER_TO_ACCOUNT_FAILURE,
  CLEAR_ACCOUNT_STATE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  GetAccountRequestAction,
  GetAccountSuccessAction,
  GetAccountFailureAction,
  InviteUserToAccountRequestAction,
  InviteUserToAccountSuccessAction,
  InviteUserToAccountFailureAction,
  ClearAccountStateAction,
  DeleteUserRequestAction,
  DeleteUserSuccessAction,
  DeleteUserFailureAction,
  UpdateUserRequestAction,
  UpdateUserSuccessAction,
  UpdateUserFailureAction,
} from './accounts.types';

// Get Account Actions
export const getAccountRequest = (): GetAccountRequestAction => ({
  type: GET_ACCOUNT_REQUEST,
});

export const getAccountSuccess = (
  response: GetAccountResponse
): GetAccountSuccessAction => ({
  type: GET_ACCOUNT_SUCCESS,
  payload: response,
});

export const getAccountFailure = (error: string): GetAccountFailureAction => ({
  type: GET_ACCOUNT_FAILURE,
  payload: error,
});

// Invite User to Account Actions
export const inviteUserToAccountRequest = (data: {
  email: string;
  firstName: string;
  lastName: string;
  role: 'admin' | 'member';
  permissions: {
    type: 'all' | 'custom';
    workspaceRole?: 'admin' | 'member';
    workspaces?: { [workspaceId: string]: string };
  };
}): InviteUserToAccountRequestAction => ({
  type: INVITE_USER_TO_ACCOUNT_REQUEST,
  payload: data,
});

export const inviteUserToAccountSuccess = (
  message: string
): InviteUserToAccountSuccessAction => ({
  type: INVITE_USER_TO_ACCOUNT_SUCCESS,
  payload: message,
});

export const inviteUserToAccountFailure = (
  error: string
): InviteUserToAccountFailureAction => ({
  type: INVITE_USER_TO_ACCOUNT_FAILURE,
  payload: error,
});

export const clearAccountState = (): ClearAccountStateAction => ({
  type: CLEAR_ACCOUNT_STATE,
});

// Delete User Actions
export const deleteUserRequest = (userId: string): DeleteUserRequestAction => ({
  type: DELETE_USER_REQUEST,
  payload: userId,
});

export const deleteUserSuccess = (
  message: string
): DeleteUserSuccessAction => ({
  type: DELETE_USER_SUCCESS,
  payload: message,
});

export const deleteUserFailure = (error: string): DeleteUserFailureAction => ({
  type: DELETE_USER_FAILURE,
  payload: error,
});

// Update User Actions
export const updateUserRequest = (data: {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  role: 'admin' | 'member';
  permissions: {
    type: 'all' | 'custom';
    workspaceRole?: 'admin' | 'member';
    workspaces?: { [workspaceId: string]: string };
  };
}): UpdateUserRequestAction => ({
  type: UPDATE_USER_REQUEST,
  payload: {
    userId: data.userId,
    data: {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      role: data.role,
      permissions: data.permissions,
    },
  },
});

export const updateUserSuccess = (
  message: string
): UpdateUserSuccessAction => ({
  type: UPDATE_USER_SUCCESS,
  payload: message,
});

export const updateUserFailure = (error: string): UpdateUserFailureAction => ({
  type: UPDATE_USER_FAILURE,
  payload: error,
});
